import { HttpClient } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { LocationService } from './location.service';
import { GeocodingService } from './geocoding.service';
import { AllinoneService } from './allinone.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { StorageService } from '../interceptor/storage.service';

@Injectable({
  providedIn: 'root',
})
export class CurrentLocationService {

  constructor(
    private locationService: LocationService,
    private geocodingService: GeocodingService,
    private allsrv: AllinoneService,
    private store: StorageService,
    private router: Router
  ) {}

  getListLocation(): void {
    this.locationService.getCurrentPosition()
  .then((position:any) => {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    this.geocodingService.getGeolocation(latitude, longitude).subscribe((response) => {
      if (response && response.results && response.results.length > 0) {
              const components = response.results[0].components;
              //console.log(components)
              localStorage.setItem('locationset', JSON.stringify(components));
              this.allsrv.setallLocation();
            }
          });
          localStorage.setItem('msgerror', 'allowed');
  })
  .catch((error) => {
    localStorage.setItem('msgerror', error?.message);
    this.checkLocation();
  });
  }

  checkLocation(): void {
    const msgError = localStorage.getItem('msgerror');
    if (msgError == 'User denied Geolocation') {
      Swal.fire({
        html: `<b>Please Allow Current Location</b> <br> <br><span style="color:red"><b>In your Browser on Top Right Side <br>or in Settings </b></span><br><br>So that you can access the application.`,
        imageUrl: "assets/img/location.png",
        imageWidth: 100,
        imageAlt: "Custom image",
        allowOutsideClick: false,
        showCancelButton: false,
        focusConfirm: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((result) => {
        if (result.isConfirmed) {
          this.router.navigate(['/Jobs']);
          Swal.close();
        }
      });
    }
  }
}

// import { Injectable } from '@angular/core';
// import { Router } from '@angular/router';
// import { AllinoneService } from './allinone.service';
// import Swal from 'sweetalert2';

// @Injectable({
//   providedIn: 'root',
// })
// export class CurrentLocationService {

//   constructor(
//     private allsrv: AllinoneService,
//     private router: Router
//   ) {}

//   getListLocation(): void {
//     // Use free IP-based API (no key required)
//     fetch('https://ipapi.co/json')
//       .then(res => res.json())
//       .then((data: any) => {
//         if (!data) return;

//         console.log("Safe Location:", data);

//         // Same format you used earlier
//         const locationData = {
//           city: data.city,
//           state: data.region,
//           country: data.country_name
//         };

//         localStorage.setItem('locationset', JSON.stringify(locationData));
//         this.allsrv.setallLocation();
//       })
//       .catch(() => {
//         console.warn("Location fetch failed (ipapi), continuing without blocking...");
//       });
//   }

//   checkLocation(): void {
//     // No need for this when using IP-based location
//   }
// }


